import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Showcase from '@/views/client/Showcase/Showcase.vue'

Vue.use(VueRouter)

  const routes: Array<RouteConfig> = [
  {
    path: '/:slug?',
    component: Showcase
    
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
